//
//  Forgot Password Actions
//  CXA Apollo
//
//  Created on 21/01/2017.
//  Copyright (c) 2017 CXA. All rights reserved.
//
//  payloads of information that send data to our store.
//

import { SubmissionError } from "redux-form";
import api from "../api/flexapi";
import { showToast } from "actions/toastActions";
import { formatDateOfBirth } from "../utils/dateOptions";

export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";
export const FORGOT_PASSWORD_CLEAN = "FORGOT_PASSWORD_CLEAN";

// Call API to load module data
export function forgotPassword(data) {
  // Return thunk middleware
  return dispatch => {
    dispatch({ type: FORGOT_PASSWORD_SUCCESS, payload: null });
    const dateOfBirth = formatDateOfBirth(data.day, data.month, data.year);

    const body = {
      companyId: data.companyId,
      loginId: data.loginId,
      dateOfBirth: (data.day || data.month || data.year) ? dateOfBirth : data.dateOfBirth,
    };

    return api
      .requestPasswordReset(body)
      .then(response => {
        dispatch({ type: FORGOT_PASSWORD_SUCCESS, payload: response });
        if (!response.body.resetPasswordURL) {
          dispatch(showToast({ message: response.body.resultMessage }));
        }
      })
      .catch(err => {
        dispatch({
          type: FORGOT_PASSWORD_FAILURE,
          payload: err.response ? err.response : err,
        });
        // server error like 505 will not have response.body
        if (err.response.body) {
          dispatch(showToast({ message: err.response.body.message }));
        }
        throw new SubmissionError({
          _error: err.response ? err.response.body.messageKey : err,
        });
      });
  };
}

export function clean() {
  return {
    type: FORGOT_PASSWORD_CLEAN,
  };
}



// WEBPACK FOOTER //
// ./actions/forgotPasswordActions.jsx